import { Container } from "react-bootstrap";
import parse from "html-react-parser";
import { RootState } from "../reducers";
import { useSelector } from "react-redux";

const PageChanges = () => {
  const textPages = useSelector((state: RootState) => state.shop.textPages);
  return (
    <Container>
       {textPages?.textChanges && parse(textPages.textChanges)}
    </Container>
  );
}
export default PageChanges;